import { CLOSE_KYC } from './KYCContstants';
import { createReducer } from '../../app/common/util/reducerUtil';

const initialState = {};

const closeKYC = (state, payload) => {
  return {
    ...state,
    close: payload,
  }
}

export default createReducer(initialState, {
  [CLOSE_KYC]: closeKYC,
});